import XMLUtils from './XMLUtils';
/**
 * Generic base parser class for parsing XML strings into json format
 * @param T type of response the parser returns
 */
export abstract class XMLBaseParser<T> {
	//entry point
	parseXML(xml: string): T {
		const json = this.parse(xml);
		return this.processParsedXML(json);
	}

	protected parse(xml: string): object {
		return XMLUtils.getInstance().parseXMLToJSON(xml);
	}

	abstract processParsedXML(json: object): T;
}
